if (!customElements.get('featured-product-size-selector')) {
  customElements.define(
    'featured-product-size-selector',
    class FeaturedProductSizeSelector extends HTMLElement {
      constructor() {
        super();
        this.onButtonClick = this.onButtonClick.bind(this);
      }

      connectedCallback() {
        for (const button of this.buttons) {
          button.addEventListener('click', this.onButtonClick);
        }
      }

      disconnectedCallback() {
        for (const button of this.buttons) {
          button.removeEventListener('click', this.onButtonClick);
        }
      }

      get buttons() {
        return this.querySelectorAll('.sachet-toggle-btn');
      }

      get form() {
        return this.closest('form');
      }

      onButtonClick(event) {
        this.selectSize(event.currentTarget);
      }

      selectSize(button) {
        if (!button || button.classList.contains('is-active')) return;

        const form = this.form;
        if (!form) return;

        for (const other of this.buttons) {
          const isActive = other === button;
          other.classList.toggle('is-active', isActive);
          other.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        }

        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) variantInput.value = button.dataset.variantId || '';

        const planRoot = form.querySelector('[data-ee-selling-plans]');
        if (planRoot) {
          const subscribe = planRoot.querySelector('[data-ee-plan="subscribe"]');
          if (subscribe) {
            subscribe.setAttribute('data-selling-plan-id', button.dataset.sellingPlanId || '');
            this.updateOption(
              subscribe,
              button.dataset.subPrice,
              button.dataset.otpPrice,
              button.dataset.subDay,
              button.dataset.compare === 'true',
              button.dataset.subPriceExact
            );
          }

          const onetime = planRoot.querySelector('[data-ee-plan="onetime"]');
          this.updateOption(onetime, button.dataset.otpPrice, '', button.dataset.otpDay, false);
        }

        this.syncActivePlan(form);
        this.updateAvailability(form, button.dataset.available !== 'false');

        this.dispatchEvent(
          new CustomEvent('fpv2:size:changed', {
            bubbles: true,
            detail: { handle: button.dataset.productHandle, variantId: button.dataset.variantId },
          })
        );
      }

      updateOption(option, price, compare, day, showCompare, atcPrice) {
        if (!option) return;

        option.setAttribute('data-price-formatted', price || '');
        if (atcPrice) {
          option.setAttribute('data-atc-price-formatted', atcPrice);
        } else {
          option.removeAttribute('data-atc-price-formatted');
        }

        const row = option.querySelector('.ee-product-selling-plan__price-row');
        const main = option.querySelector(
          '.ee-product-selling-plan__price:not(.ee-product-selling-plan__price--compare)'
        );
        if (main) {
          main.textContent = price || '';
          main.classList.toggle('ee-product-selling-plan__price--sale', !!showCompare);
        }

        let compareEl = option.querySelector('.ee-product-selling-plan__price--compare');
        if (showCompare) {
          if (!compareEl && row) {
            compareEl = document.createElement('span');
            compareEl.className = 'ee-product-selling-plan__price ee-product-selling-plan__price--compare';
            row.appendChild(compareEl);
          }
          if (compareEl) {
            compareEl.textContent = compare || '';
            compareEl.hidden = false;
          }
        } else if (compareEl) {
          compareEl.hidden = true;
        }

        this.setText(option, '.ee-product-selling-plan__day', day ? `(${day}/day)` : '');
      }

      syncActivePlan(form) {
        const root = form.querySelector('[data-ee-selling-plans]');
        if (!root) return;

        const selected = root.querySelector('[data-ee-plan].is-selected') || root.querySelector('[data-ee-plan]');
        if (!selected) return;

        const hidden = root.querySelector('[data-ee-selling-plan]');
        if (hidden) hidden.value = selected.getAttribute('data-selling-plan-id') || '';

        const priceEl = form.querySelector('[data-ee-selling-plan-price]');
        const formatted =
          selected.getAttribute('data-atc-price-formatted') || selected.getAttribute('data-price-formatted') || '';
        if (priceEl && formatted) priceEl.textContent = formatted;
      }

      updateAvailability(form, available) {
        const button = form.querySelector('.featured-product-v2__atc');
        if (!button) return;

        const label = button.querySelector('.featured-product-v2__atc-label');
        if (available) {
          button.removeAttribute('disabled');
          button.setAttribute('data-fpv2-atc', '');
          if (label && button.dataset.fpv2LabelCache) label.textContent = button.dataset.fpv2LabelCache;
          return;
        }

        if (label && !button.dataset.fpv2LabelCache) button.dataset.fpv2LabelCache = label.textContent;
        button.setAttribute('disabled', 'disabled');
        if (label) label.textContent = this.dataset.soldOutLabel || '';
      }

      setText(scope, selector, value) {
        const el = scope ? scope.querySelector(selector) : null;
        if (el && value) el.textContent = value;
      }
    }
  );
}
